import { IReportColumn } from '@opengov/reporting-types/src/reportColumns-immer';
import { DateTime } from 'luxon';

import { ECalculationDateFormats, luxonDateFormats } from './types';

export const getDateFormatFromColumn = (column: IReportColumn): ECalculationDateFormats => {
  const dateMetadata = column.metadata && column.metadata.facts && column.metadata.facts.maximum;
  if (!dateMetadata) {
    return ECalculationDateFormats.YearMonthDay;
  }
  let dateFormat = ECalculationDateFormats.YearMonthDay;
  (Object as any).values(ECalculationDateFormats).forEach((format) => {
    const luxonDate = DateTime.fromFormat(dateMetadata, luxonDateFormats[format]);
    if (luxonDate.isValid) {
      dateFormat = format;
    }
  });
  return dateFormat;
};
